export type Translations = Map<string, string>;

/*
 * Aggregation of both CNS and Shop Categories
 * API supported Animal Types
 * */
export enum AnimalTypeEnum {
    DOGS = 'DOGS',
    CATS = 'CATS',
    FISH = 'FISH',
    RODENTS = 'RODENTS',
    REPTILES = 'REPTILES',
    HORSES = 'HORSES',
    BIRDS = 'BIRDS',
    OFFERS = 'OFFERS',
    FARM_ANIMALS = 'FARM_ANIMALS',
}

export enum CategoryTypeEnum {
    NORMAL = 'NORMAL',
    ANIMAL = 'ANIMAL',
    BRANDS = 'BRANDS',
    OFFERS = 'OFFERS',
    SPECIAL_OFFERS = 'SPECIAL_OFFERS',
    TRIAL_OFFERS = 'TRIAL_OFFERS',
    NEW_PRODUCTS = 'NEW_PRODUCTS',
    OUTLET = 'OUTLET',
}

export enum FlyoutTypeEnum {
    ANIMAL = 'ANIMAL',
    BRAND = 'BRAND',
    SPECIALS = 'SPECIALS',
}

export interface UiCategory {
    animalType?: string;
    children?: UiCategory[];
    description: string;
    extId: number;
    level: number;
    path: string;
    pictureFile?: string;
    specials?: UiCategory[];
    title: string;
    type?: CategoryTypeEnum;
    whitespaceAfter?: number;
    highlighted: boolean;
    hasMore?: boolean;
}

export interface UiCategoryExt extends UiCategory {
    active: boolean;
    children?: UiCategoryExt[];
    specials?: UiCategoryExt[];
}

export type Bundle = 'zooplus' | 'bitiba';

export type UiBannerItem = {
    targetLink: string;
    linkAriaLabel: string | null;
    desktopImage: string | null;
    desktopImageAltText: string | null;
    mobileImage: string | null;
    mobileImageAltText: string | null;
};

export type UiBanner = {
    dog: UiBannerItem | null;
    cat: UiBannerItem | null;
    specials: UiBannerItem | null;
    root: UiBannerItem | null;
};

export type Cart = {
    summary: {
        articleCount: number;
    };
};
